import React from 'react';

function SubmitButton() {
  return (
    <div className="submit-btn-wrapper">
      <button className="btn btn-animated" type="submit">
        Submit
      </button>
    </div>
  );
}

export default SubmitButton;
